import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {FormGeneratorService} from "../../components/common/fields/form-generator.service";
import {FieldDefinition} from "../../model/field-definition";
import {Product} from "../../model/product";

@Injectable({
  providedIn: 'root'
})
export class UserProductsFormGeneratorService implements FormGeneratorService {

  constructor() {
  }

  getQuestions(allowedProducts: {key: string, value: string}[]): Observable<FieldDefinition<any>[]> {
    const questions = [
      new FieldDefinition<Product>({
        key: 'product',
        label: 'Logiciel concerné',
        type: 'select',
        placeholder: 'Sélectionner le logiciel concerné',
        required: true,
        options: allowedProducts,
        order: 1
      }),
      new FieldDefinition<string>({
        key: "transfert",
        label: 'Le transfert de compétences à été réalisé',
        type: 'btn-radio',
        required: true,
        options: [
          {key: 'libriciel', value: "Par un consultant Libriciel SCOP"},
          {key: 'interne', value: "En interne"},
        ],
        order: 2
      }),
      new FieldDefinition<string>({
        key: "formateur",
        label: 'Nom et prénom du formateur',
        type: 'text',
        required: true,
        order: 3
      }),
    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }
}
